import { AlertCircle } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export const AccountNotVerified = () => {
  const navigate = useNavigate();

  return (
    <div className="container mx-auto px-4 py-8">
      <Card className="p-8 max-w-2xl mx-auto rounded-custom-paddings">
        <div className="flex flex-col items-center text-center space-y-4">
          <AlertCircle className="w-16 h-16 text-yellow-500" />
          <h1 className="text-2xl font-bold">Account Not Verified by an Admin</h1>
          <p className="text-muted-foreground">
            Your account has not been verified yet, either because you are not an independent developer, or this is an error<b className="text-yellow-600">*</b>. 
            <br /> <br /> 
            If you believe this is an error, please don't hesitate to <span className="text-primary hover:underline cursor-pointer" onClick={() => navigate("/contact")}>contact us</span>.
          </p>
          <p className="text-muted-foreground text-sm bg-yellow-500/10 p-2 px-4 rounded-full text-yellow-600 mt-3">
            * An indie developer account may take up to 5 business days to be verified.
          </p>
          
        </div>
      </Card>
    </div>
  );
};

